// =============================
// File: src/kc.js
// =============================
import Keycloak from "keycloak-js";
import { KEYCLOAK_CONFIG, USE_SILENT_SSO } from "./envconfigs";

export const keycloak = new Keycloak(KEYCLOAK_CONFIG);

let initPromise;
export function initKeycloak() {
  if (!initPromise) {
    initPromise = keycloak.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      checkLoginIframe: false,
      redirectUri: window.location.origin,
      ...(USE_SILENT_SSO
        ? { silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html` }
        : {}),
    });
  }
  return initPromise;
}

